import Dropdown from 'antd/es/dropdown';
import 'antd/es/dropdown/style/css';

export default Dropdown;
